import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase.js';

/**
 * Modal for starting a new online challenge -- either targeted at a specific
 * player, or as a shareable link anyone can claim. Calls onChallengeCreated
 * after either succeeds so the caller can refresh its challenge lists.
 */
export default function NewChallengeModal({ show, onHide, players, onChallengeCreated }) {
  const [challengePlayerId, setChallengePlayerId] = useState('');
  const [error, setError] = useState(null);
  const [sending, setSending] = useState(false);
  const [generatingLink, setGeneratingLink] = useState(false);

  async function handleChallengePlayer(e) {
    e.preventDefault();
    if (!challengePlayerId) return;
    setSending(true);
    setError(null);
    try {
      const createChallenge = httpsCallable(functions, 'createChallenge');
      await createChallenge({ toPlayerId: challengePlayerId });
      setChallengePlayerId('');
      onChallengeCreated?.();
      onHide();
    } catch (err) {
      setError(err.message);
    } finally {
      setSending(false);
    }
  }

  async function handleCreateChallengeLink() {
    setGeneratingLink(true);
    setError(null);
    try {
      const createChallenge = httpsCallable(functions, 'createChallenge');
      await createChallenge({});
      onChallengeCreated?.();
      onHide();
    } catch (err) {
      setError(err.message);
    } finally {
      setGeneratingLink(false);
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>New Challenge</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={handleChallengePlayer}>
          <Form.Group className="mb-2">
            <Form.Label>Challenge a player</Form.Label>
            <Form.Select value={challengePlayerId} onChange={e => setChallengePlayerId(e.target.value)}>
              <option value="">Select a player…</option>
              {players.map(p => (
                <option key={p.id} value={p.id}>{p.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Button type="submit" className="w-100" disabled={sending || !challengePlayerId}>
            {sending ? 'Sending…' : 'Send challenge'}
          </Button>
        </Form>

        <div className="d-flex align-items-center my-3 text-muted small">
          <hr className="flex-grow-1" />
          <span className="mx-2">or</span>
          <hr className="flex-grow-1" />
        </div>

        <Button
          className="w-100"
          onClick={handleCreateChallengeLink}
          disabled={generatingLink}
        >
          {generatingLink ? 'Generating…' : 'Create challenge link'}
        </Button>
      </Modal.Body>
    </Modal>
  );
}
